<script lang="js">
import Navbar from "@/components/base/StaffNavbar.vue";
import Sidebar from "@/components/base/StaffSidebar.vue";


export default {
  data() {
    return {};
  },
  methods: { },
  computed: {
    hideStaffHeader() {
      return this.$route.meta.hideStaffHeader || false;
    },
    hideStaffSidebar() {
      return this.$route.meta.hideStaffSidebar || false;
    },
  },
  components: { Navbar, Sidebar },
};
</script>

<template>
  <div class="container-fluid p-0 vh-100">
    <div class="vh-100 d-flex flex-column">
      <!-- Top Navbar -->
      <Navbar v-if="!hideStaffHeader"></Navbar>

      <!-- Main Layout (Sidebar + Content) -->
      <div
        class="d-flex flex-grow-1"
        :style="{
          marginTop: hideStaffHeader ? '0' : '56px',
          height: hideStaffHeader ? '100vh' : 'calc(100vh - 56px)',
        }"
      >
        <!-- Fixed Sidebar -->
        <Sidebar v-if="!hideStaffSidebar"></Sidebar>

        <!-- Main Content (Scrollable) -->
        <div
          class="flex-grow-1 overflow-auto"
          style="background-color: #f4f4f4"
        >
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
